import { BindingHelpers } from 'vuex-class/lib/bindings';
import { namespace } from 'vuex-class';
import { ITagState } from './tag.types';

export const tagsModuleName = 'tags';
export const Tags: BindingHelpers = namespace(tagsModuleName);

export function getDefaultState(): ITagState {
  return {
    tags: [],
    loading: false,
    loaded: false,
  };
}

export enum ETagAction {
  Create = 'create',
  CreateSuccess = 'createSuccess',
  CreateFailed = 'createFailed',
  Load = 'loadTags',
  LoadSuccess = 'loadSuccess',
  LoadFailed = 'loadFailed',
}

export enum ETagMutation {
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetTags = 'setTags',
  AddTag = 'addTag',
}
